$(document).ready(function () {
  if ($(".past-newsletters li").length > 0) {
    $(".past-newsletters li").each(function () {
      var link = $(this).find("a").attr("href");

      var linkText = $(this).find("a").text();
      console.log("linkText: ", linkText);
      var fullText = $(this).text();
      console.log("fullText: ", fullText);

      var date = fullText.replace(linkText + ", ", "");
      console.log("date: ", date);

      var content = "";
      content += "<p class='newsletter-date'>";
      content += date;
      content += "</p>";
      content += "<p class='newsletter-link'>";
      content += "<a href='" + link + "'>";
      content += linkText;
      content += "</a>";
      content += "</p>";
      $(this).empty();
      $(this).append(content);
    });
  }
});
